import { SalesOrderAccounting } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1400. 受注案件管理会計登録
 * [POST] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/sales_order_accountings
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  year_month: string;
  monthly_amount?: number;
  spot_amount?: number;
};
const createSalesOrderAccounting = (props: Props): Promise<SalesOrderAccounting> => {
  return axios.post(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/sales_order_accountings`,
    props
  );
};
export const useCreateSalesOrderAccounting = () => {
  return useMutation({
    mutationFn: createSalesOrderAccounting
  });
};